import http from '../../plugins/http.js';
import { Search, Category, Resource, PayTypes, filterResponse, Upload } from '@/http/resources.js';
const search = new Search({
  http,
  onResourcesFetched: (data) => {
    eve('onResourcesFetched', null, data);
  }
});
const category = new Category({ http });
const resource = new Resource({ http });
const upload = new Upload({ http });
const state = {
  isSearchAll: false,
  globalKeyword: '',
  totalDict: {},
  payTypeTexts: {
    free: '免费',
    pay: '付费',
    person: '会员专属',
    company: '企业会员专属'
  },
  hotWords: {

  },
  cates: {},
  addingData: {},
  // 付费信息
  commonvipMaterial: [],
  componyvipMaterial: []
}

const getters = {
  commonvipMaterial: state => state.commonvipMaterial,
  componyvipMaterial: state => state.componyvipMaterial,
  totalDict: state => state.totalDict,
  isSearchAll: state => state.isSearchAll,
  globalKeyword: state => state.globalKeyword,
  cates: state => state.cates,
  addingData: state => state.addingData,
  resourceTypeToText: () => {
    return {
      template: '模板',
      scene: '场景',
      background: '背景',
      text: '文字',
      character: '角色',
      material: '素材',
      shape: '形状',
      prop: '道具',
      gif: 'GIF',
      sound: '声音',
      combo: '组合',
      gesture: '手势'
    }
  }
}

const mutations = {
  setCommonvipMaterial (state, val) {
    if (val) {
      state.commonvipMaterial.push(val);
    } else {
      state.commonvipMaterial = [];
    }
  },
  setComponyvipMaterial (state, val) {
    if (val) {
      state.componyvipMaterial.push(val);
    } else {
      state.componyvipMaterial = [];
    }
  },
  setIsSearchAll (state, flag = false) {
    state.isSearchAll = flag;
    if (!flag) {
      state.totalDict = {};
    }
  },
  setGlobalKeyword (state, text) {
    state.globalKeyword = text;
  },
  setTotalDict (state, dict) {
    state.totalDict = dict;
  },
  setCates (state, { id, type } = {}) {
    state.cates[type] = {
      id,
      type
    }
  },
  setAddingData (state, data) {
    state.addingData = data;
  }
}

const actions = {
  async uploadImage (store, payload) {
    return await upload.image(payload);
  },
  async uploadScene (store, payload) {
    return await upload.scene(payload);
  },
  async category (store, payload) {//分类
    return await category.get({ params: payload.params });
  },
  async getTemplateCate (store, payload) {
    return await category.get({ params: { ...payload.params, type: 8 } });
  },
  async getHotWords (store, payload) {
    let hotWords = store.state.hotWords[payload.type];
    if (!hotWords) {
      const res = await search.getHotWords({ type: payload.type }) || {};
      store.state.hotWords = {
        ...store.state.hotWords,
        [payload.type]: res.data
      };
      hotWords = store.state.hotWords[payload.type];
    }
    return hotWords
  },
  getPayTypes (store) {
    return Object.keys(PayTypes).map(v => {
      return {
        type: v,
        text: store.state.payTypeTexts[v]
      }
    })
  },
  async search (store, payload) {
    // return await search.get({url: '/api/common/material', params: payload.params});
    // let style = store.rootGetters['StyleMsg'];
    let params = { ...payload.params };
    let options = payload.options;
    return await search.get({
      params,
      options
    });
  },
  async searchScene (store, payload) {
    // let style = store.rootGetters['StyleMsg'];
    return await search.get({
      params: {  ...payload.params, type: 'scene' },
      options: payload.options
    });
  },
  async searchTemplate (store, payload) {
    // let style = store.rootGetters['StyleMsg'];
    return await search.get({
      params: { ...payload.params, type: 'template' },
      options: payload.options
    });
  },
  async searchBackground (store, payload) {//背景
    // let style = store.rootGetters['StyleMsg'];
    return await search.get({
      params: { ...payload.params, type: 'background' },
      options: payload.options
    });
  },
  async searchText (store, payload) {
    // let style = store.rootGetters['StyleMsg'];
    return await search.get({
      params: { ...payload.params, type: 'text' },
      options: payload.options
    });
  },
  async searchCharacter (store, payload) {//角色
    // let style = store.rootGetters['StyleMsg'];
    return await search.get({
      params: { ...payload.params, type: 'character' },
      options: payload.options
    });
  },
  async searchMaterial (store, payload) {
    // let style = store.rootGetters['StyleMsg'];
    return await search.get({
      params: { type: 'material', ...payload.params, },
      options: payload.options
    });
  },
  async searchSound (store, payload) {
    // let style = store.rootGetters['StyleMsg'];
    return await search.get({
      params: { ...payload.params, type: 'sound' },
      options: payload.options
    })
  },
  async searchAll (store, payload) {
    let res = await search.searchAll({
      keyword: payload.keyword
    });
    if (res && res.data) {
      store.commit('setTotalDict', res.data);
    }
    return res;
  },
  async likes (store, { id = '', flag = true, type } = {}) {
    return await resource.likes({
      id,
      flag,
      type
    });
  },
  async getRecent (store, { type = '', direction = '' } = {}) {
    return await search.getRecent({
      type,
      direction
    });
  },
  async setRecent (store, { type = '', id = '', direction = void 0 } = {}) {
    return await search.setRecent({
      type,
      id,
      direction
    })
  },
  async getSpaceSize ({ params = {} } = {}) {
    let url = '/api/user/material/size';
    const resp = await http.get(url, { params });
    return filterResponse(resp);
  },
  async getUploaded (store, payload) {
    return search.getUploaded(payload);
  },
  async getUserCate (store, payload) {
    return search.getUserCate(payload);
  },
  async searchUserItem (store, payload) {
    return search.searchUserItem(payload);
  },
  async getTeamItems (store, payload) {
    return search.getTeamItems(payload);
  },
  async removeUserItem (store, payload) {
    return search.removeUserItem({
      id: payload.id,
      type: payload.type
    })
  },
  async addUploadedItem (store, payload) {
    return search.addUploadedItem(payload);
  },
  async setUploadedItem (store, payload) {
    return search.setUploadedItem(payload)
  },
  openLib (store, payload) {
    let { id: cateId } = store.state.cates[payload.type] || {}
    let navParams = {
      optimized: '',
      category: '',
      ...payload.navParams
    };
    if (cateId) {
      navParams.category = cateId;
    }
    store.commit("open_TemplateMaterialLibDialogMsg", {
      materialType: payload.materialType,
      navParam: navParams
    }, { root: true });
  },
  matchType (store, fileType) {
    let fileTypes = [fileType - 0];
    if (Array.isArray(fileType)) {
      fileTypes = fileType.map(v => v - 0);
    }
    let map = {
      15: [6, 7, 23, 28, 29, 8, 30],
      17: [3, 4, 22, 46, 5, 42]
    };
    let names = {
      3: '免抠元素',
      6: '免抠元素',
      4: '手绘SVG',
      7: '手绘SVG',
      22: '手绘SVG',
      23: '手绘SVG',
      28: '手绘SVG',
      29: '手绘SVG',
      46: '手绘SVG',
      5: '矢量动图',
      8: '矢量动图',
      42: '有声素材',
      // 8: '图表组合',
      30: '图表组合',
    }
    let dict = {
      '免抠元素': [3, 6],
      '手绘SVG': [4, 7, 22, 23, 28, 29, 46],
      '矢量动图': [5, 8],
      '有声素材': [42],
      '图表组合': [8, 30]
    }

    let list = fileTypes.map(v => {
      return {
        type: v,
        name: names[v]
      }
    });

    let keys = [];
    list.forEach(v => {
      let current = keys.find(item => item.name === v.name);
      if (!current) {
        keys.push({
          name: v.name,
          type: [v.type]
        });
      } else {
        current.type.push(v.type)
      }
    });
    return keys;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/resources.js